import { injectIntl } from "react-intl";
import { connect } from "react-redux";

import LanguagePage from "./LanguagePage";
import { post, get } from "../../../actions/general";

const mapDispatchToProps = {
    post,
    get,
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LanguagePage));
